<script>
  import { Link } from 'svelte-routing';
</script>

<div class="not-found-container">
  <div class="not-found-content">
    <h1>404</h1>
    <h2>Halaman Tidak Ditemukan</h2>
    <p>Maaf, halaman yang Anda cari tidak ditemukan.</p>
    <div class="not-found-actions">
      <Link to="/" class="home-button">Kembali ke Beranda</Link>
    </div>
  </div>
</div>

<style>
  .not-found-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 2rem;
    background-color: #f5f7fa;
  }
  
  .not-found-content {
    text-align: center;
    max-width: 500px;
  }
  
  h1 {
    font-size: 6rem;
    font-weight: 700;
    margin: 0;
    color: #2563eb;
    line-height: 1;
  }
  
  h2 {
    font-size: 2rem;
    margin: 0 0 1rem;
    color: #1e3a8a;
  }
  
  p {
    margin-bottom: 2rem;
    color: #64748b;
    font-size: 1.125rem;
  }
  
  .not-found-actions {
    margin-top: 2rem;
  }
  
  .home-button {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    background-color: #2563eb;
    color: white;
    text-decoration: none;
    border-radius: 4px;
    font-weight: 500;
    transition: background-color 0.2s;
  }
  
  .home-button:hover {
    background-color: #1d4ed8;
  }
</style>